class SizeTabs {
  constructor() {
    this.tabsInit();
  }

  tabsInit() {
    let tabsButton = document.querySelectorAll('.tabs--button');
    let tabItems = document.querySelectorAll('.tab--items');
    let tabButtonsBar = document.querySelector('.tabs--button-bar');

    if (!tabsButton || !tabItems) {
      return;
    }

    tabsButton.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        const {id} = event.currentTarget;
        const targetPanel = document.querySelector(`[aria-labelledby="${id}"]`);

        if (tabButtonsBar) {
          let left = window.getComputedStyle(tabButtonsBar, ':after').getPropertyValue('left');
          console.log(`Left: ${left}`);

          if (index == 1) {
            
          } else if (index == 2) {
            
          }
        }

        tabsButton.forEach((tabButton) => {
          tabButton.setAttribute('aria-selected', false);
        });

        tabItems.forEach((panel, index) => {
          panel.hidden = true;
        });

        event.currentTarget.setAttribute('aria-selected', true);
        targetPanel.hidden = false;
      });
    });
  }
}

export default SizeTabs;